<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <h2 class="blind">가입신청 완료</h2>
      <div class="message-box" tabindex="0">
        <p class="message-text">
          가입신청이 완료되었습니다.<br />
          <strong class="primary-text">LG U<sup>+</sup></strong
          >를 선택해주셔서 감사합니다.
        </p>
        <div class="section-separator" />
        <div class="group-horizontal">
          <p class="message-text">
            <span class="message-text-small">신청번호</span>
            <span class="space"></span>
            <span class="message-text-temp">{{ this.onlnAppfNo }}</span>
          </p>
        </div>
        <div class="section-separator" />
        <p class="data-text">
          <span class="dynamic-data-temp">{{this.dealNm}}</span>
          을(를) 통해
          <span class="space"></span>
          <span>{{ this.aplcNmMask }}</span>
          님의 LG유플러스 서비스 가입신청이 접수되었습니다.<br />
        </p>
      </div>
      <div class="section">
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              가입신청과 관련한 문의는 신청하신 대리점으로 연락주시기 바랍니다.
            </li>
          </ul>
        </div>
      </div>
      <!-- 구매자 정보 -->
      <!-- 중고 아닐 경우 -->
      <div class="registration-page" v-if="payYn !== 'Y'">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>구매자 정보</h3>
            </div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">구매대리점</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.dealNm }} ( {{ this.sbgnDealCd }} )
                    </p>
                  </div>
                </dd>
                <dt class="field-label">
                  <label for="">구매쇼핑몰</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.opmkNm }}
                    </p>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- 가입자 -->
      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>가입자</h3>
            </div>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">고객구분</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ custKdNm }}
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">가입자명</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ this.aplcNmMask }}
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">연락처</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ this.aplcTlnoMask }}
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">주민등록번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p id="customer-id-number-confirmed" class="data-text">
                    <span>{{ this.ssn1 }}</span>
                    <span class="field-group-space">-</span>
                    <span>{{ this.ssn2 }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">인증종류</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text" v-if="onetIdcdDivsCd === 'REGID'">
                    <span>주민등록증</span>
                  </p>
                  <p class="data-text" v-if="onetIdcdDivsCd === 'HANDI'">
                    <span>장애인등록증</span>
                  </p>
                  <p class="data-text" v-if="onetIdcdDivsCd === 'DRIVE'">
                    <span>운전면허번호</span>
                  </p>
                  <p class="data-text" v-if="onetIdcdDivsCd === 'MERIT'">
                    <span>국가유공자(10종)</span>
                  </p>
                  <p class="data-text" v-if="onetIdcdDivsCd === 'NAMEC'">
                    <span>대한민국여권</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group" v-if="onetIdcdDivsCd === 'DRIVE'">
              <dt class="field-label">
                <label for="">운전면허번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span>{{ drvLcnsNoStr }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group" v-if="onetIdcdDivsCd === 'MERIT'">
              <dt class="field-label">
                <label for="">보훈번호</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span>{{ monmCsntNo }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl
              class="field-group"
              v-if="onetIdcdDivsCd !== 'NAMEC' && onetIdcdDivsCd !== ''"
            >
              <dt class="field-label">
                <label for="">발급일자</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span>{{ isuDtStr }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">고객주소</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span>{{ billDivsNm }}</span
                    ><br />
                    <!-- {{ this.crplZpcd }} {{ this.crplAddr }} {{ this.crplDadr }} -->
                    <!-- 상세주소 안보여주기 -->
                    {{ this.crplZpcd }} {{ this.crplAddr }}
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">정보알림</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ bltxRcepMthdNm }}
                  </p>
                  <!--  2025-11-27 수정
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      E-mail(상세) 또는 휴대폰(간편) 신청 시 매월 무료문자
                      15건(300원) 제공
                    </li>
                  </ul>
                  -->
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="">E-mail</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ this.aplcEmalAddrMask }}
                  </p>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      가입예약 내용 및 e-mail(상세) 청구서를 받으시기 위해
                      필요한 것으로 정확한 이메일 주소를 입력해주세요.
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- 납부정보 시작 -->
      <!-- 중고 일 경우 -->
      <div class="registration-page" v-if="payYn === 'Y' || entrLoc === 'B'">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>납부정보</h3>
            </div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">납부방법</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p id="customer-type-confirmed" class="data-text">
                      {{ paymMthdDivsNm }}
                      <span v-if="paymMthdDivsCd !== 'G'">
                        <!-- ) {{this.bankCdcoNm}} {{this.acctCardNo}} -->
                        {{ bankNm }} {{ this.acctCardNoMask }}
                        <span v-if="paymMthdDivsCd === 'C'">
                          (유효기간 ****/**)</span
                        >
                      </span>
                    </p>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- 가입내역 시작 -->
      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>가입내역</h3>
            </div>
            <div class="section-body">
              <!-- <div class='section-body'> -->
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">단말기 모델명</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.dvicMdlNm }}
                    </p>
                  </div>
                </dd>
                <dt class="field-label">
                  <label for="">단말일련번호</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.trmSrno }}
                    </p>
                  </div>
                </dd>
              </dl>
              <!-- </div> -->
            </div>
            <div class="section-body" v-if="(this.imei+'').length > 0 || this.entrLoc == 'B'">
              <!-- <div class='section-body'> -->
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">유심모델명</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.usimMdlNm }}
                    </p>
                  </div>
                </dd>
                <dt class="field-label">
                  <label for="">유심일련번호</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.usimSn }}
                    </p>
                  </div>
                </dd>
              </dl>
              <!-- </div> -->
            </div>
            <div class="section-body" v-if="(this.imei+'').length > 0">
              <!-- <div class='section-body'> -->
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">개통국번</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.ctn }}
                    </p>
                  </div>
                </dd>
                <dt class="field-label">
                  <label for=""></label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                    </p>
                  </div>
                </dd>
              </dl>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 신청내역 시작  -->
      <!-- 신규, 번호이동 -->
      <div
        class="registration-page"
        v-if="opmkEntrKdCd === 'new' || opmkEntrKdCd === 'move'"
      >
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>신청내역</h3>
            </div>
            <div class="section-body">
              <!-- <div class='section-body'> -->
              <dl class="field-group">
                <dt class="field-label">
                  <label for="">요금제</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      {{ this.ppNm }}
                    </p>
                  </div>
                </dd>
                <dt class="field-label">
                  <label for=""></label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                    </p>
                  </div>
                </dd>
              </dl>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 배송지 시작 -->
      <!-- 중고 일 경우 -->
      <div class="registration-page" v-if="payYn === 'Y' && (this.imei+'').length < 1 && this.entrLoc == ''">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>배송지</h3>
            </div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  수취인명
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">{{ this.dlvRcipNmMask }}</p>
                  </div>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  주소
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      <span>{{ this.dlplZpcd }}</span
                      ><br />
                      <span class="input-sub-text">{{ this.dlplBadr }}</span
                      >
                      <!-- 상세주소 안보여주기 -->
                      <!-- <br />
                      <span class="input-sub-text">{{ this.dlplDadr }}</span> -->
                    </p>
                  </div>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  수취인 연락처1
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      <span>{{ this.dlplTlnoMask }}</span>
                    </p>
                  </div>
                </dd>
              </dl>
              <dl class="field-group" v-if="dlvCtplNm !== ''">
                <dt class="field-label">
                  수취인 연락처2
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">
                      <span>{{ this.dlplTlno2Mask }}</span>
                    </p>
                  </div>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  추가요청사항
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <p class="data-text">{{ this.addReqMttrCntn }}</p>
                  </div>
                </dd>
              </dl>
              <ul class="notice-text-list">
                <li class="notice-text">
                  본인은 이동통신서비스 가입 신청내역, 각종 요금제, 이용에 관한
                  안내등 약관의 중요내용 및 개인정보수집, 이용제공에 대하여
                  충분히 이해하고 이에 동의하며 이용약관에 따라 위와같이
                  이동통신서비스를 신청하는 바입니다.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 닫기 -->
      <div v-if="this.carType !== 'B'"  class="step-bottom-area input-wrap">
        <button type="submit" @click="returnUrl" class="primary-button mw100 pc-float-right">
          확인
        </button>
      </div>
    </div>
    <v-dialog />
    <iframe v-if="this.carType == 'A'" :src="$store.state.connectedCar.returnUrl" id="fHidd2" width="0" height="0" frameborder="0"></iframe>

  </div>

</template>

<script>
import { watchRefreshKeyPress } from '@/system/common'
import { getAppFormData } from '@/api/connectedCar/step2'
export default {
  name: 'ConnectedCarStep3',
  components: {
  },
  props: {},
  computed: {
    custKdNm() {
      if (this.custKdCd === 'A' || this.custKdCd === 'B') {
        return '개인'
      }
      if (this.custKdCd === 'C') {
        return '법인'
      }
      if (this.custKdCd === 'D') {
        return '외국인'
      }
      return ''
    },
    acctCardNo() {
      let size = this.crypAcctCardNo.length
      let first = this.crypAcctCardNo.substring(0, 2)
      let last = this.crypAcctCardNo.substring(size - 4, size)
      return first + '**********' + last
    },
    paymMthdDivsNm() {
      if (this.paymMthdDivsCd === 'B') return '은행'
      if (this.paymMthdDivsCd === 'C') return '카드'
      if (this.paymMthdDivsCd === 'G') return '지로'
      return ''
    },
    bltxRcepMthdNm() {
      if (this.bltxRcepMthdCd === '2') {
        return 'E-MAIL(청구서 내용 상세)'
      }
      if (this.bltxRcepMthdCd === '5') {   // 휴대폰(청구서 내용 간편) 에서  App 청구서 로 변경 (2025.11.27)
        return 'App 청구서'
      }
      if (this.bltxRcepMthdCd === '13') {  // [CSR ID:RITM2464842] 청구서유형 추가 (2025.11.27)
        return 'E-MAIL + App 청구서'
      }
      return ''
    },
    ssn1() {
      return this.aplcDernoMask ? this.aplcDernoMask.substr(0, 6) : ''
    },
    ssn2() {
      return this.aplcDernoMask ? this.aplcDernoMask.substr(6, 7) : ''
    },
    billDivsNm() {
      if (this.billDivsCd === 'H') {
        return '자택'
      }
      if (this.billDivsCd === 'O') {
        return '직장'
      }
      if (this.billDivsCd === 'E') {
        return '기타'
      }
      return ''
    },
    isuDtStr() {
      let year = this.isuDt.substring(0, 4)
      let month = this.isuDt.substring(4, 6)
      let day = this.isuDt.substring(6, 8)
      return year + '년 ' + month + '월 ' + day + '일 발급'
    },
    drvLcnsNoStr() {
      return (
        this.drvLcnsIsuAreaCd +
        this.drvLcnsNo.substring(0, 2) +
        '-' +
        this.drvLcnsNo.substring(2, 8) +
        '-' +
        this.drvLcnsNo.substring(8, 10)
      )
    }
  },
  data() {
    return {
      payYn: '', // 중고여부
      appfNo: '', // 가입신청번호
      crypAppfNo: '', // 암호화 가입신청번호
      onlnAppfNo: '', // 평문신청번호
      dealNm: '', // 대리점명
      sbgnDealCd: '', //대리점코드
      opmkNm: '', // 구매쇼핑몰
      custKdCd: '', // 고객구분코드
      aplcNm: '', // 고객명
      aplcNmMask: '', // 마스킹 고객명
      aplcTlno: '', // 연락처
      aplcTlnoMask: '', //연락처 마스킹
      aplcDernoMask: '', // 주민번호 mask
      onetIdcdDivsCd: '', // 인증구분코드
      isuDt: '', // 발급일자
      drvLcnsIsuAreaCd: '', // 운전면허 지역코드
      drvLcnsNo: '', // 운전면허번호
      crplZpcd: '', // 청구지 우편 번호
      crplAddr: '', // 청구지 주소
      crplDadr: '', // 청구지 상세 주소
      aplcEmalAddr: '', // 이메일
      aplcEmalAddrMask: '', //마스킹 이메일
      bltxRcepMthdCd: '', //청구서선택코드
      billDivsCd: '', // 청구위치 구분코드
      paymMthdDivsCd: '', // 납부방법 구분코드
      crypAcctCardNo: '', // 카드번호
      acctCardNoMask: '', // 카드번호 마스킹
      dvicMdlNm: '', // 단말기 모델명
      usimMdlNm: '', // 유심모델명
      usimSn: '', // 유심일련번호
      ctn: '', // 개통국번
      trmSrno: '', // 단말기 일련번호
      ppNm: '', // 요금제
      dlvRcipNm: '', // 수취인명
      dlvRcipNmMask: '', // 마스킹 배송수령자
      dlplZpcd: '', // 배송지 우편 번호
      dlplBadr: '', // 배송지 주소
      dlplDadr: '', // 배송지 상세 주소
      dlplTlno: '', // 수취인 연락처1
      dlplTlnoMask: '', //마스킹 배송지전화번호
      dlvCtplNm: '', // 수취인 연락처2
      dlplTlno2Mask: '', //마스킹 배송지전화번호 2
      addReqMttrCntn: '', // 추가요청사항
      opmkEntrKdCd: '', // 가입유형코드
      bankNm: '', // 은행명
      retrieveData: {
        appfNo: '',
        crypAppfNo: '',
        accessType: 'L'
      },
      carType:'',
      imei: '',
      entrLoc: '' // location이 'B'일경우 도요타 후석시스템 신청
    }
  },
  created() {
    watchRefreshKeyPress()
  },
  beforeCreate() {},
  mounted() {
    this.$store.state.processIndicator.step1 = false
    this.$store.state.processIndicator.step2 = false
    this.$store.state.processIndicator.step3 = true
    this.$store.state.processIndicator.step4 = true

    this.imei = this.$store.state.connectedCar.common.imei
    this.entrLoc = this.$store.state.connectedCar.common.entrLoc
    
    if((this.imei+"").length < 1) {
      if(this.entrLoc == ''){ //닛산
        this.carType = "A"; 
      }
      else { //도요타 후석
        this.carType = "C"
      }
    } else if((this.imei+"").length > 0) {//도요타
      this.carType = "B";
    }

    this.payYn = this.$store.state.connectedCar.common.payYn
    this.retrieveData.appfNo = this.$route.params.appfNo
    this.retrieveData.crypAppfNo = this.$route.params.crypAppfNo

    // 앞에서 작성한 정보 가져오기
    getAppFormData(this.retrieveData).then(res => {
      this.appfNo = res.data.opmktRegistrationCapture.appfNo
      this.crypAppfNo = res.data.opmktRegistrationCapture.crypAppfNo
      this.onlnAppfNo = res.data.opmktRegistrationCapture.onlnAppfNo
      this.aplcNm = res.data.opmktRegistrationCapture.aplcNm
      this.aplcNmMask = res.data.opmktRegistrationCapture.aplcNmMask
      this.dealNm = res.data.opmktRegistrationCapture.dealNm
      this.sbgnDealCd = res.data.opmktRegistrationCapture.sbgnDealCd
      this.opmkNm = res.data.opmktRegistrationCapture.opmkNm
      this.aplcTlno = res.data.opmktRegistrationCapture.aplcTlno
      this.aplcTlnoMask = res.data.opmktRegistrationCapture.aplcTlnoMask
      this.aplcDernoMask = res.data.opmktRegistrationCapture.aplcDernoMask
      this.crplZpcd = res.data.opmktRegistrationCapture.crplZpcd
      this.crplAddr = res.data.opmktRegistrationCapture.crplAddr
      this.crplDadr = res.data.opmktRegistrationCapture.crplDadr
      this.aplcEmalAddr = res.data.opmktRegistrationCapture.aplcEmalAddr
      this.aplcEmalAddrMask = res.data.opmktRegistrationCapture.aplcEmalAddrMask
      this.crypAcctCardNo = res.data.opmktRegistrationCapture.crypAcctCardNo
      this.acctCardNoMask = res.data.opmktRegistrationCapture.acctCardNoMask
      this.dvicMdlNm = res.data.opmktRegistrationCapture.dvicMdlNm
      this.usimMdlNm = this.$store.state.connectedCar.common.usimMdlNm
      this.usimSn = this.$store.state.connectedCar.common.usimSn
      this.ctn = this.$store.state.connectedCar.common.ctn
      this.trmSrno = res.data.opmktRegistrationCapture.trmSrno
      this.ppNm = res.data.opmktRegistrationCapture.ppNm
      this.dlvRcipNm = res.data.opmktRegistrationCapture.dlvRcipNm
      this.dlvRcipNmMask = res.data.opmktRegistrationCapture.dlvRcipNmMask
      this.dlplZpcd = res.data.opmktRegistrationCapture.dlplZpcd
      this.dlplBadr = res.data.opmktRegistrationCapture.dlplBadr
      this.dlplDadr = res.data.opmktRegistrationCapture.dlplDadr
      this.dlplTlno = res.data.opmktRegistrationCapture.dlplTlno
      this.dlplTlnoMask = res.data.opmktRegistrationCapture.dlplTlnoMask
      this.dlvCtplNm = res.data.opmktRegistrationCapture.dlvCtplNm
      this.dlplTlno2Mask = res.data.opmktRegistrationCapture.dlplTlno2Mask
      this.paymMthdDivsCd = res.data.opmktRegistrationCapture.paymMthdDivsCd
      this.bltxRcepMthdCd = res.data.opmktRegistrationCapture.bltxRcepMthdCd
      this.billDivsCd = res.data.opmktRegistrationCapture.billDivsCd
      this.custKdCd = res.data.opmktRegistrationCapture.custKdCd
      this.addReqMttrCntn = res.data.opmktRegistrationCapture.addReqMttrCntn
      this.opmkEntrKdCd = res.data.opmktRegistrationCapture.onetKdCd
      this.bankNm = res.data.opmktRegistrationCapture.bankNm
      if (res.data.entrRsvTruthInfo !== null) {
        this.onetIdcdDivsCd = res.data.entrRsvTruthInfo.onetIdcdDivsCd
        this.isuDt = res.data.entrRsvTruthInfo.isuDt
        this.drvLcnsNo = res.data.entrRsvTruthInfo.drvLcnsNo
        this.drvLcnsIsuAreaCd = res.data.entrRsvTruthInfo.drvLcnsIsuAreaCd
      }
    })

    if(this.carType == 'B') {
      // setTimeout(() => { // C20220725_39868_4539868 3초 딜레이 삭제 요청 
         //alert("완료")
         window.location.replace(this.$store.state.connectedCar.returnUrl)// 3000ms(3초)가 경과하면  함수를 실행합니다.
      //}, 3000)
    }
    // if(this.carType == 'C') {
    //   this.trmSrno = this.$store.state.connectedCar.common.itemSn
    // }
  },
 

  methods: {
    /**
     * Function    : returnUrl
     * Description : 최종 확인 버튼 클릭 이벤트
     **/
    returnUrl() {

      if(this.carType == 'B') {
        window.location.href = this.$store.state.connectedCar.returnUrl;
      } else {
        this.$modal.show('dialog', {
          title: '<h1>온라인 가입신청 안내</h1>',
          text:
            '온라인가입등록이 완료되었습니다. 추후 문자메시지를 통해서 개통유무를 확인할 수 있습니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                  self.close()
                  this.$modal.hide('dialog')
                
              }
            }
          ]
        })
      }
      
    }
  }
}
</script>

<style scoped></style>
